module.exports = __webpack_public_path__ + "img/delete_member.81080fa6.svg";